import "./two-column-image-text-grid.scss";

export class TextColumnImageTextGridComponent {
  constructor() {
    this.init();
  }

  init() {
    this.initSmoothScroll();
  }

  initSmoothScroll() {
    const container = document.querySelector<HTMLElement>(
      ".two-column-image-text-grid"
    );

    if (!container) return;

    const anchor = container.querySelector<HTMLElement>(".js-link-scroll");

    anchor.addEventListener("click", (event: Event) => {
      event.preventDefault();

      const targetId = anchor.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (!targetElement) return;

      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }
}
